import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddCities, Cities } from '../models/cities/cities';



@Injectable({
  providedIn: 'root'
})
export class CitiesService {

  constructor(
    private _http: HttpClient
  ) { }

    public getCities(CitiesId?: number): Observable<Cities[]>{
        return this._http.get<Cities[]>(`${environment.api.url}/Cities?CitiesId=${CitiesId??''}`);
    }
  
    public deleteCities(CitiesId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/Cities/${CitiesId}`);
    }
  
    public addCities(model: AddCities): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/Cities`, model);
    }
}
